import { FadeInOut } from './FadeInOut';
import { Grow } from './Grow';

export const Animated = {
  FadeInOut,
  Grow,
};
